<template>
<div>
  <div class="main-content">
    <div class="content-block box">
      <div class="content">
        <div class="box action-buttons">
          <button class="pure-button lump-btn" @click="showLumpModal = true" v-show="isAdmin && checkPeriod">一括登録</button>
          <button class="pure-button receipt-copy-btn" @click="printImg" v-show="isAdmin">領収書印刷</button>
        </div>
        <div class="transport-detail-area" :style="{ height: 'calc(100% - ' + buttonAreaHeight + 'px)' }">
          <table class="pure-table" ref="table">
            <thead class="table-header" ref="thead">
              <tr :style="{ width: theadTrWidth }">
                <td class="td-date">日付</td>
                <td class="td-from">出発地</td>
                <td class="td-to">到着地</td>
                <td class="td-parking">駐車場</td>
                <td class="td-fee">交通費</td>
                <td class="td-fee">お客様請求</td>
                <td class="td-meany-type">交通手段</td>
                <td class="td-matter">用件</td>
                <td class="td-receipt">領収書</td>
              </tr>
            </thead>
            <tbody :style="{ height: tbodyHeight + 'px' }">
              <tr class="tr-hover" ref="tbodyTr" v-for="transport in transports" :key="transport.ID" 
                :class='{ active: transport.ID == choicedID }' @click="choice(transport.ID)">
                <td class="td-date">{{ transport.Ymd }}</td>
                <td class="td-from">{{ transport.FromStation }}</td>
                <td class="td-to">{{ transport.ToStation }}</td>
                <td class="td-parking">{{ transport.Parking }}</td>
                <td class="fee td-fee">{{ transport.TransportFee.toLocaleString() }} 円</td>
                <td class="fee td-fee">{{ transport.ChargeToCustomerFee.toLocaleString() }} 円</td>
                <td class="td-meany-type">{{ meanyType(transport.MeanyType) }}</td>
                <td class="td-matter">
                  <p class="matter">{{ transport.Matter }}</p>
                </td>
                <td class="td-receipt">
                  <a v-if="transport.ImageEntry != 0"
                    :href="'https://' + urlBase + '/v1/transports/get/receipt/' + transport.ID" 
                    data-lightbox="abc" 
                    :data-title="imageTitle(transport)"
                  >
                    ●
                  </a>
                </td>
              </tr>
            </tbody>
            <tfoot ref="tfoot">
              <tr class="tr-tfoot">
                <td class="td-tfoot">
                  <button class="add-btn" @click="addTransport" v-if="!isChoiced" v-show="isAdmin && checkPeriod">追加</button>
                  <button class="edit-btn" @click="editTransport()" v-if="isChoiced" v-show="isAdmin && checkPeriod">編集</button>
                  <button class="delete-btn" @click="deleteTransport" v-if="isChoiced" v-show="isAdmin && checkPeriod">削除</button>
                  <div class="footer-fee">
                    <span>交通費合計：</span><span class="total-fee">{{ totalFee('TransportFee') }}</span><span class="yen"> 円</span>
                    <span>お客様請求合計：</span><span class="total-fee">{{ totalFee('ChargeToCustomerFee') }}</span><span class="yen"> 円</span>
                    <span>金額合計：</span><span class="total-fee">{{ totalFee('FeeTotal') }}</span><span> 円</span>
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
          <!-- 一括登録のモーダル -->
          <transition name="modal">
            <div class="modal-mask" v-if="showLumpModal">
              <div class="modal-wrapper">
                <div class="modal-container-lump">
                  <form @submit.prevent="regist">
                    <div class="modal-lump">交通費 一括登録</div>
                    <div class="modal-file">
                      <input type="file" name="file" @change="selectFile" accept=".csv" required>
                    </div>
                    <button class="pure-button modal-regist-button">登録</button>
                    <button type="button" class="pure-button modal-cancel-button" @click="showLumpModal = false">キャンセル</button>
                  </form>
                </div>
              </div>
            </div>
          </transition>
          <!-- 追加・編集のモーダル -->
          <transition name="modal">
            <div class="modal-mask" v-if="showEditModal">
              <div class="modal-wrapper">
                <div class="modal-container">
                  <form @submit.prevent="updateTransport">
                    <table>
                      <tr>
                        <td class="modal-label" name="date">日付</td>
                        <td><input type="date" class="modal-details" v-model="transport.ymd" :min="min" :max="max" required></td>
                      </tr>
                      <tr class="modal-from-station">
                        <td class="modal-label" name="from-station">出発地</td>
                        <td><input type="from-station" class="modal-details" v-model="transport.fromStation" :required="transport.meanyType!=3"></td>
                      </tr>
                      <tr class="modal-to-station">
                        <td class="modal-label" name="to-station">到着地</td>
                        <td><input type="to-station" class="modal-details" v-model="transport.toStation" :required="transport.meanyType!=3"></td>
                      </tr>
                      <tr class="modal-parking">
                        <td class="modal-label" name="parking">駐車場</td>
                        <td><input type="parking" class="modal-details" v-model="transport.parking" :required="transport.meanyType==3"></td>
                      </tr>
                      <tr class="modal-fee">
                        <td class="modal-label" name="fee">金額</td>
                        <td><input type="fee" class="modal-details-fee" v-model="transport.fee" required><span class="modal-fee-yen">円</span></td>
                      </tr>
                      <tr class="modal-meany-type">
                        <td class="modal-label" name="meany-type">交通手段</td>
                        <td class="meany-type-down">
                          <select name=meanyType-down” class="modal-details" v-model="transport.meanyType">
                            <option value="0">電車</option>
                            <option value="1">バス</option>
                            <option value="2">タクシー</option>
                            <option value="3">駐車場</option>
                          </select>
                        </td>
                      </tr>
                      <tr class="modal-matter">
                        <td class="modal-label" name="matter">用件</td>
                        <td><input type="matter" class="modal-details" v-model="transport.matter" required></td>
                      </tr>
                      <tr class="modal-charge_to_customer_flg">
                        <td class="modal-label" name="charge_to_customer_flg">お客様請求</td>
                        <input type="checkbox" id="charge_to_customer_flg" name="checkbox-customer" class="modal-details" v-model="transport.chargeToCustomerFlg">
                      　<label for="charge_to_customer_flg" class="checkbox-customer"></label>
                      </tr>
                        <tr class="modal-receipt">
                          <td rowspan="2" class="modal-label" name="receipt">領収書</td>
                          <td class="modal-details">
                            {{ transport.imageEntry == 0 ? "画像なし" : "画像あり" }}
                            <input type="checkbox" class="modal-details" v-model="transport.receipt" id="delete" name="receipt">
                      　    <label for="delete" class="receipt" v-if="transport.imageEntry != 0">削除</label>
                          </td>
                        </tr>
                        <tr>
                          <td class="modal-details"><input type="file" ref="file" name="file"></td>
                        </tr>
                    </table>
                    <button class="pure-button modal-regist-button">登録</button>
                    <button type="button" class="pure-button modal-cancel-button" @click="showEditModal = false">キャンセル</button>
                  </form>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import moment from "moment"
import "lightbox2/src/js/lightbox.js"

export default {
  data() {
    return {
      observer: null,
      tableHeight: 0,
      theadHeight: 0,
      tfootHeight: 0,
      tbodyTrWidth: 0,

      name: this.$route.query.name,
      transports: {},
      transport: {
        ymd: "",
        fromStation: "",
        toStation: "",
        parking: "",
        fee: 0,
        meanyType: 0,
        matter: "",
        chargeToCustomerFlg: false,
        receipt: false,
        imageEntry: 0,
      },
      urlBase: process.env.VUE_APP_API_URL_BASE,
      showEditModal: false,
      showLumpModal: false,
      file: null,
      isChoiced: false,
      choicedID: null,
      min: moment(this.$route.query.month).format("YYYY-MM-01"),
      max: moment(this.$route.query.month).endOf("month").format("YYYY-MM-DD"),
    }
  },

  beforeMount() {
    this.$emit("send", this.getTransportDetail)
  },

  mounted() {
    this.setResizeObserver()
  },
  
  beforeDestroy() {
    this.removeResizeObserver()
  },

  watch: {
    transports() {
      this.$nextTick(() => {
        this.getSizeForLayout()
      })
    }
  },

  computed: {
    isAdmin() {
      return this.$store.state.store.user.auth == 0
    },

    checkPeriod() {
      return this.$route.query.checkStatus != 1
    },

    meanyType() {
      return function(type) {
        switch (type) {
          case 0:
            return "電車"
          case 1:
            return "バス"
          case 2:
            return "タクシー"
          default:
            return "駐車場"
        }
      }
    },
    
    totalFee() {
      return function(type) {
        return this.transports == null || Object.keys(this.transports).length == 0
                ? 0 
                : this.transports
                      .reduce((current, next) => current + Number(next[type]), 0)
                      .toLocaleString()
      }
    },

    imageTitle() {
      return function(transport) {
        var title = transport.Ymd + '&emsp;'
        if (transport.MeanyType <= 2) {
          title = title +
                  transport.FromStation + ' - ' + 
                  transport.ToStation + '&emsp;'
        } else {
          title = title + transport.Parking + '&emsp;'
        }
        title = title +
                '交通費: ' + transport.TransportFee.toLocaleString() + '円' + '&emsp;' + 
                'お客様請求: ' + transport.ChargeToCustomerFee.toLocaleString() + '円' + '&emsp;' + 
                this.meanyType(transport.MeanyType) + '&emsp;' + 
                transport.Matter

        return title
      }
    },

    tbodyHeight() {
      return this.tableHeight - (this.theadHeight + this.tfootHeight)
    },

    theadTrWidth() {
      return this.tbodyTrWidth == 0 ? 'auto' : this.tbodyTrWidth + 'px'
    },

    buttonAreaHeight(){
      return this.isAdmin == true ? 75 : 33
    }
  },

  methods: {
    getTransportDetail() {
      this.$http.get("/transport_detail", {
        params: {
          id: this.$route.query.id,
          month: moment(this.$route.query.month).format("YYYY年M月1日")
        }})
        .then((res) => {
          this.transports = res.data.transports
        })
    },

    printImg() {
      let location = this.$router.resolve({ name: 'images_sheet', query: { month: moment(this.$route.query.month).format('YYYY/M'), name: this.$route.query.name,id: this.$route.query.id }})
      window.open(location.href)
    },

    setResizeObserver() {
      this.observer = new ResizeObserver(function() {
        this.theadHeight = this.$refs.thead.clientHeight
        if (this.$refs.tbodyTr && 0 < this.$refs.tbodyTr.length) {
          this.tbodyTrWidth = this.$refs.tbodyTr[0].clientWidth
        }
      }.bind(this))

      this.observer.observe(this.$refs.thead)
    },

    removeResizeObserver() {
      this.observer.unobserve(this.$refs.thead)
    },

    getSizeForLayout() {
      this.tableHeight = this.$refs.table.clientHeight - 4
      this.theadHeight = this.$refs.thead.clientHeight
      this.tfootHeight = this.$refs.tfoot.clientHeight
      if (this.$refs.tbodyTr && 0 < this.$refs.tbodyTr.length) {
        this.tbodyTrWidth = this.$refs.tbodyTr[0].clientWidth
      }
    },

    //一括登録　CSVファイルを読み込む    
    selectFile: function(e) {
      const file = e.target.files[0]
      this.file = file
    },

    //読み込んだファイルをcsvファイルとして処理
    regist() {
      //csvファイルじゃなかったら
      if (!this.file.name.toUpperCase().match(/\.(CSV)$/i)) {
        alert("CSVファイルを選択してください")  
        return
      }
      
      const reader = new FileReader()
      const transports = []

      const loadFunc = () => {
        var csvText = reader.result
        const lines = csvText.split("\r\n")

        lines.forEach(element => {
          const transportData = element.split(",")

          if (transportData.length != 8) return

          const transport = {
            user_id: Number(this.$route.query.id),
            ymd: transportData[0],
            from_station: transportData[1],
            to_station: transportData[2],
            parking: transportData[3],
            fee: transportData[4],
            meany_type: transportData[5],
            matter: transportData[6],
            charge_to_customer_flg: transportData[7]
          }
          transports.push(transport)
        })

        if (confirm("ファイルを登録しますか？")) {
          this.$http.post("/add_transport_details", {
            transports: transports
          })
          .then(() => {
            this.getTransportDetail()
            this.showLumpModal = false
          })
          .catch(() => {
            alert("ファイルの追加に失敗しました。")
          })
        }
      }
      reader.onload = loadFunc
      reader.readAsText(this.file)
    },

    choice(transportID) {
      //choicedID内のIDとtransportIDの値が等しいか判定
      if (this.choicedID == transportID) {
        this.choicedID = null
        this.isChoiced = false

      //行選択時、データを挿入
      } else {   
        this.choicedID = transportID
        this.isChoiced = true

        let choicedTransport = this.transports.filter(transport => transport.ID == this.choicedID)
        
        let md = moment(choicedTransport[0].Ymd, "M月D日").format("MM-DD")
        let y = moment(this.$route.query.month).format("YYYY-")

        let fee = Math.max(choicedTransport[0].TransportFee, choicedTransport[0].ChargeToCustomerFee)
      
        this.transport.ymd = y + md 
        this.transport.fromStation = choicedTransport[0].FromStation
        this.transport.toStation = choicedTransport[0].ToStation
        this.transport.parking = choicedTransport[0].Parking
        this.transport.fee = fee
        this.transport.meanyType = choicedTransport[0].MeanyType
        this.transport.matter = choicedTransport[0].Matter
        this.transport.chargeToCustomerFlg = choicedTransport[0].ChargeToCustomerFee != 0
        this.transport.imageEntry = choicedTransport[0].ImageEntry
        this.transport.receipt = false
      }
    },

    addTransport(){
      this.showEditModal = true

      this.transport.ymd = ""
      this.transport.fromStation = ""
      this.transport.toStation = ""
      this.transport.parking = ""
      this.transport.fee = 0
      this.transport.meanyType = 0
      this.transport.matter = ""
      this.transport.chargeToCustomerFlg = false
      this.transport.imageEntry = 0
    },

    editTransport() {
      this.showEditModal = true
    },

    updateTransport() {
      var image = this.$refs.file.files[0]
      var imageEntry = this.$refs.file.files.length
      
      if (this.transport.receipt == true && imageEntry == 0) {
        image = null
        imageEntry = 1
      }
      
      var form = new FormData()
      form.append("user_id", this.$route.query.id)
      form.append("id", this.choicedID)
      form.append("ymd", this.transport.ymd)
      form.append("from_station", this.transport.fromStation)
      form.append("to_station", this.transport.toStation)
      form.append("from_station_code", "")
      form.append("to_station_code", "")
      form.append("parking", this.transport.parking)
      form.append("fee", this.transport.fee)
      form.append("meany_type", this.transport.meanyType)
      form.append("matter", this.transport.matter)
      form.append("charge_to_customer", this.transport.chargeToCustomerFlg)
      form.append("image", image)
      form.append("image_entry", imageEntry)
      const config = {
        headers: {
          "content-type": "multipart/form-data"
        },
      }

      if (confirm("登録しますか？")) {
        var url = this.isChoiced == true ? "/update_transport" : "/add_transport"
        this.$http.post(url, form, config)
          .then(() => {
            this.getTransportDetail()
            this.showEditModal = false
          })
          .catch(() => {
            alert("登録に失敗しました。")
          })
      }
    },

    deleteTransport() {
      if (confirm("交通費を削除しますか？")) {
        this.$http.get("/delete_transport", {
          params: { 
            transportID: this.choicedID,
            id: this.$route.query.id,
            ymd: this.transport.ymd
          }
        })
        .then(() => {
          this.getTransportDetail()
          this.isChoiced = false
        })
        .catch(() => {
          alert("交通費の削除に失敗しました。")
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~lightbox2/src/css/lightbox.css";

.action-buttons {
  width: 98%;
  margin-top: 10px;
  text-align: right;
}

.transport-detail-area {
  width: 95%;
  display: grid;
}

//一括登録ボタン
.lump-btn {
  margin: 2px 0 7px 0;
  background: linear-gradient(-45deg, #fff5ee, #bce2e8);
}

//一括登録のモーダル
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;

  td {
    padding: 6px;
  }

  tr {
    display: table-row;
  }
}

.modal-container-lump {
  width: 30%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-lump {
  font-weight: bold;
  margin: 10px 0 25px 0px;
  font-size: 23px;
}

.modal-file {
  margin: 5%;
}

//領収書印刷ボタン
.receipt-copy-btn {
  float: right;
  margin: 2px 19px 7px 10px;
  background: linear-gradient(135deg, #fff5ee, #bce2e8);
}

table {
  table-layout: fixed;
  margin: 0 0 0 0;
}

.table-header {
  background: linear-gradient(180deg, #fffaf0, #dcdcdc);
}

td, th {
  table-layout: fixed;
}

.td-date {
  width: 10%;
  padding: 0px;
}

.td-from, .td-to {
  width: 12%;
  padding: 0px;
}

.td-parking {
  width: 13%;
  padding: 0px;
}

.td-fee {
  width: 10%;
  padding: 10px;
}

.td-meany-type {
  width: 9%;
  padding: 0px;
}

.td-matter {
  width: 15%;
  padding: 0px;

  .matter {
    font-size: 14px;
  }
}

.td-receipt {
  width: 8%;
  padding: 0px;
}

.fee {
  text-align: right;
}

.tr-tfoot {
  margin: 0 0 -5px 0;
  background: linear-gradient(0deg, #fffaf0, #d3d3d3);
}

.td-tfoot {
  border: 0px;
  text-align: right;
  padding: 0px 20px 0px 20px;
}

.footer-fee {
  margin: 15px 0;
}

.yen {
  margin-right: 25px;
}

.total-fee {
  display: inline-block;
}

//追加・編集・削除のボタン
.add-btn, .edit-btn, .delete-btn {
  display: inline-block;
  float: left;
  padding: 0.5em 1em;
  margin: 8px 15px 10px 15px;
  text-decoration: none;
  background: #ffffff;
  border: #f0f8ff;
  font-weight: bold;
  box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.29);
}

.add-btn {
  border-left: solid 6px #3bc2c2; /*左線*/
  color: #009999; /*文字色*/
}

.edit-btn {
  border-left: solid 6px #6495ed; /*左線*/
  color: #230daf; /*文字色*/
}

.delete-btn {
  border-left: solid 6px #FF6666; /*左線*/
  color: #dc143c; /*文字色*/
}

.add-btn:active, .edit-btn:active, .delete-btn:active {
  box-shadow: inset 0 0 2px rgba(128, 128, 128, 0.1);
  transform: translateY(2px);
}

//追加・編集のモーダル
.modal-container {
  width: 500px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-details {
  width: -webkit-fill-available;
}

.modal-details-fee {
  width: 98%;
}

//「円」の表示
.modal-fee-yen {
  margin: 0 5px 0 -23px;
}

// 交通手段のプルダウン
.meany-type-down {
  position: relative;
}

//「▼」の表示位置
.meany-type-down:after {
  content: '▼';
  left: 323px;
  top: 9px;
  position: absolute;
  pointer-events: none;
}

// プルダウン幅
.meany-type-down select {
  -webkit-appearance: none;
  height: 25px;
  border-radius: 2px;
  padding: 3px;
}

//お客様請求チェックボックス・領収書削除チェックボックス
input[type=checkbox] {
  display: none;
}

.checkbox-customer, .receipt {
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block;
  position: relative;
  width: auto;
}

.checkbox-customer {
  padding: 5px 30px;
}

.receipt {
  padding: 0px 32px;
}

.checkbox-customer::before, .receipt::before {
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 3px;
  content: '';
  display: block;
  height: 16px;
  width: 16px;
}

.receipt::before {
  left: 80px;
  position: absolute;
  top: 1%;
}

.checkbox-customer::after, .receipt::after {
  content: '';
  display: block;
  height: 20px;
  opacity: 0;
  position: absolute;
  top: 50%;
  transform: rotate(45deg) translate3d(0,2px,0) scale3d(.7,.7,1);
  transition: transform .2s ease-in-out, opacity .2s ease-in-out;
  width: 9px;
}

.checkbox-customer::after {
  border-right: 6px solid #1c74d8;
  border-bottom: 3px solid #1c74d8;
  left: 33px;
  margin-top: -17px;
}

.receipt::after {
  border-right: 6px solid #FF0033;
  border-bottom: 3px solid #FF0033;
  left: 83px;
  margin-top: -20px;
}

input[type=checkbox]:checked + .checkbox-customer::before,
input[type=checkbox]:checked + .receipt::before {
  border-color: #666;
}

input[type=checkbox]:checked + .checkbox-customer::after,
input[type=checkbox]:checked + .receipt::after {
  opacity: 1;
  transform: rotate(45deg) scale3d(1,1,1);
}

.modal-regist-button {
  margin: 15px 20px;
  background: linear-gradient(-45deg, #fff5ee, #bce2e8);
}

.modal-cancel-button {
  margin: 15px 10px;
  background: linear-gradient(135deg, #ffffb7, #FF6666);
}

.modal-enter, .modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container-lump {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-label {
  width: 30%;
}

//行選択
.active {
  background-color: rgba(255, 252, 93, 0.507);
}


//スマホ用CSS
@media screen and (max-width: 420px) {
  .action-buttons {
    display: none;
  }

  .transport-detail-area {
    overflow-x: scroll;
  }

  table {
    table-layout: unset;
  }

  tr {
    table-layout: fixed;
  }

  .td-date {
    width: 65px;
  }

  .td-from, .td-to {
    width: 90px;
  }

  .td-parking {
    width: 90px;
  }

  .td-fee {
    width: 50px;
  }

  .td-meany-type {
    width: 65px;
  }

  .td-matter {
    width: 100px;
  }

  .td-receipt {
    width: 50px;
  }
}
</style>